module.exports = __webpack_public_path__ + "static/media/295067.434d28ea.png";